












import {defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: 'FilterCard',
  props: {
    title: {type: String},
    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        switch (value) {
          case 'small':
          case 'default':
            return true;
          default:
            return false;
        }
      }
    }
  }
})
